import getToken from "../../utils/getToken"
import { API } from "../../config/api"

export default async (id) => {
    try{
        const token = getToken()

        const response = await fetch(`${API}/reviews/${id}`,{
            method:'DELETE',
            headers:{
                'Content-Type':'application/json',
                'Authorization': `Bearer ${token}`
            },
        })

        const {success,review} = await response.json()

        return {success,review}
    }catch(error){
        console.log(error)

        return {success:false}
    }
}